module.exports = __webpack_public_path__ + "static/collide_crowd-a0afe2b60b8773602d4cec0e382e5d06.jpg";